import { useState, useEffect } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'

const darkTheme = {
    card: {
        bg: '#242426',
        border: '#353536',
        bgImg: '#2e2e31',
    },
    text: {
        title: '#f0f4f8',
        paragraph: '#9fa6ad'
    },
    chevron: {
        active: '#9fa6ad',
        disabled: '#3b3b3e',
        bgHover: '#2e2e31',
        bgActive: '#3a3a3e',
    },
    dots: {
        unactive: '#3b3b3e'
    }
}

const lightTheme = {
    card: {
        bg: '#fbfcfe',
        border: '#cdd7e1',
        bgImg: '#f0f4f8',
    },
    text: {
        title: '#181a1c',
        paragraph: '#5b646e'
    },
    chevron: {
        active: '#626b74',
        disabled: '#d3dde7'
    },
    dots: {
        unactive: '#f0f4f8'
    }
}

const theme = {
    light: lightTheme,
    dark: darkTheme,
}

export const useCurrentTheme = () => {
    const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)')
    const [mode, setMode] = useState(prefersDarkMode ? 'dark' : 'light')

    useEffect(() => {
        setMode(prefersDarkMode ? 'dark' : 'light')
    }, [prefersDarkMode])

    return theme[mode]
}
